/*! Copyright © 2026 Kontextlab GmbH. All rights reserved. */

/*
 * The token that opens a map nobody is signed in to see.
 *
 * A reader is given a link carrying `?access=…`, and the server sets a
 * cookie so the rest of the page's requests need not repeat it. That
 * cookie is not always sent: a map embedded in someone else's page is a
 * cross-site request, and a browser will withhold it there. So every
 * request that needs the token asks for it here and puts it in the URL
 * rather than trusting the cookie to arrive.
 *
 * Its own module rather than `links.js`, which `cookie.js` already
 * imports: a cycle between those two takes the whole bundle down.
 */

import { getConfig } from './config.js';

/**
 * The access token for this map, if the reader has one.
 *
 * The address is asked first. A reader following a shared link has the
 * token there before anything else knows it, and if it differs from the
 * one the page was built with, theirs is the one they mean.
 *
 * @returns {string|null} The token, or nothing.
 */
export function accessToken() {
    const fromAddress = new URLSearchParams(window.location.search).get(
        'access'
    );
    if (fromAddress) return fromAddress;

    const fromConfig = getConfig()?.access?.token;
    return fromConfig || null;
}

export default accessToken;
